import { Box, Flex, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { HasuraContextWrapper } from '@/client/context/hasura'

import LiveHelpNotificationBubble from '@/components/Community/LiveHelp/LiveHelpNotificationBubble'
import type { NavigationItemSlug } from '@/components/Layout/types'
import { useSharedNavigationItems } from '@/components/Layout/useSharedNavigationItems'
import ShwLink from '@/components/ShwLink'
import useMemberWorlds from '@/components/Worlds/hooks/world/useMemberWorlds'

export const NAVBAR_HEIGHT = '64px'

export default function NavbarMobile({ activeNavItem }: { activeNavItem?: NavigationItemSlug }) {
  const sharedNavigationItems = useSharedNavigationItems()
  const tutorWorldIds = useMemberWorlds(['id'], 'tutor').map(world => world.id)
  return (
    <>
      <Box
        flexShrink={0}
        display={{ base: 'block', sm: 'none' }}
        width="100dvw"
        height={NAVBAR_HEIGHT}
      />
      <Flex
        bottom="0px"
        width="100dvw"
        position="fixed"
        display={{ base: 'flex', sm: 'none' }}
        zIndex={3}
        direction="row"
        bgColor="bg"
        height="64px"
        borderTop="1px solid"
        borderColor="border"
        justifyContent="stretch"
      >
        {sharedNavigationItems.map(item => {
          const isActive = item.slug === activeNavItem
          const isLiveHelp = item.slug === 'live-help'

          return (
            <ShwLink
              key={item.href}
              href={item.href}
              _focus={{ outline: 'none' }}
              textDecoration="none"
              flexGrow={1}
              minWidth="50px"
            >
              <Flex
                direction="column"
                alignItems="center"
                justifyContent="center"
                px="8px"
                py="8px"
                bgColor={isActive ? 'primary.subtle' : 'transparent'}
                height="64px"
                gap="4px"
                position="relative"
              >
                <FontAwesomeIcon
                  icon={isActive ? item.icons.active : item.icons.inactive}
                  width="20px"
                  color={chakraTokenToVar(isActive ? 'primary.fg' : 'fg')}
                />
                <Text
                  textAlign="center"
                  fontSize="10px"
                  fontWeight={isActive ? 600 : 500}
                  lineHeight="1"
                  color={isActive ? 'primary.fg' : 'fg'}
                  noOfLines={1}
                >
                  {item.labels.mobile}
                </Text>
                {isLiveHelp ? (
                  <HasuraContextWrapper LoadingComponent={() => null}>
                    <LiveHelpNotificationBubble tutorWorldIds={tutorWorldIds} />
                  </HasuraContextWrapper>
                ) : null}
              </Flex>
            </ShwLink>
          )
        })}
      </Flex>
    </>
  )
}
